import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { JourneyTypes } from "#/components/get-reimbursed/steps/ExpenseJourneyTypes"
import { Benefit } from "#/lib/carrot-api/types/Benefit"
import { defineMessage, MessageDescriptor, useIntl } from "react-intl"

type ExpenseRelatedToChoice = {
  label: MessageDescriptor
  value: JourneyTypes
  filter?: (j: any, benefit?: Benefit) => boolean
}
const reimbursementJourneys: ExpenseRelatedToChoice[] = [
  {
    value: JourneyTypes.ADOPTION,
    label: defineMessage({ defaultMessage: "Adoption" }),
    filter: (j) => j.adoption.hasEligibleExpenses
  },
  {
    value: JourneyTypes.FERTILITY_CARE,
    label: defineMessage({ defaultMessage: "Fertility care" }),
    filter: (j) => j.fertilityCare.hasEligibleExpenses
  },
  {
    value: JourneyTypes.PRESERVATION,
    label: defineMessage({ defaultMessage: "Fertility preservation" }),
    filter: (j) => j.fertilityPreservation.hasEligibleExpenses
  },
  {
    value: JourneyTypes.GENDER_AFFIRMING_CARE,
    label: defineMessage({ defaultMessage: "Gender-affirming care" }),
    filter: (j) => j.genderAffirmingCare.hasEligibleExpenses
  },
  {
    value: JourneyTypes.GC,
    label: defineMessage({ defaultMessage: "Gestational surrogacy" }),
    filter: (j) => j.gestationalCarrier.hasEligibleExpenses
  },
  {
    value: JourneyTypes.LOW_TESTOSTERONE,
    label: defineMessage({ defaultMessage: "Low testosterone" }),
    filter: (j) => j.lowTestosterone.hasEligibleExpenses
  },
  {
    value: JourneyTypes.MENOPAUSE,
    label: defineMessage({ defaultMessage: "Menopause" }),
    filter: (j) => j.menopause.hasEligibleExpenses
  },
  {
    value: JourneyTypes.METABOLIC_FERTILITY_HEALTH,
    label: defineMessage({ defaultMessage: "Metabolic-fertility health" }),
    filter: (j, b) => b?.sprints?.fertilityCare?.enabled
  },
  {
    value: JourneyTypes.PREGNANCY_AND_POSTPARTUM_SERVICES,
    label: defineMessage({ defaultMessage: "Pregnancy and postpartum services" }),
    filter: (j, b) =>
      j.pregnancy.hasEligibleExpenses &&
      (b.journeys.pregnancy.eligibleExpensesDetail.milkShippingCovered ||
        b.journeys.pregnancy.eligibleExpensesDetail.doulaExpensesCovered ||
        b.journeys.pregnancy.eligibleExpensesDetail.childbirthClassesCovered)
  },
  {
    value: JourneyTypes.PATHFINDING,
    label: defineMessage({ defaultMessage: "Something else" })
  }
]

export function useFilteredAndFormattedReimbursementJourneyOptions() {
  const { data: benefit } = useBenefit()
  const intl = useIntl()
  return reimbursementJourneys
    .filter((c) => !c.filter || c.filter(benefit.journeys, benefit))
    .map((journeyOption) => ({
      ...journeyOption,
      label: intl.formatMessage(journeyOption.label)
    }))
}
